import React from "react";
/**
 * @deprecated В v3 будет удалено
 */ export var IconSettingsProvider = function(param) {
    var children = param.children;
    return children;
};

//# sourceMappingURL=IconSettings.js.map